import BoardContentContext from '@/context/apps/board/BoardContentContext';
import CommentContext from '@/context/apps/comment/CommentContext';
import { type ReactNode, useContext, useMemo } from 'react';

import { getAppsBdOptions } from '@/data/apps/bd';

import BoardDetailPagination from '@/components/apps/board/detail/BoardDetailPagination';
import BoardDetailTop from '@/components/apps/board/detail/BoardDetailTop';
import Area from '@/components/apps/layouts/shared/Area';
import ReplySection from '@/components/shared/ui/reply/ReplySection';

type Props = {
  contentHeader?: ReactNode;
};

export default function BoardDetail({ contentHeader }: Props) {
  const context = useContext(BoardContentContext);
  const { data } = context;
  const { bc } = data;

  const bdOptions = getAppsBdOptions(bc.board.layout);
  const isNews = useMemo(
    () => bc.board.id === 'news' || bc.board.id === 'news_en',
    [bc.board.id],
  );

  return (
    <div
      className="pt-[60px]"
      style={
        isNews
          ? {
              maxWidth: '700px',
              margin: '0 auto',
            }
          : {}
      }
    >
      <Area>
        {/* 디테일 탑 */}
        <BoardDetailTop />
        {contentHeader}
        {/* 디테일 컨텐츠 */}
        {bdOptions?.detail}
        {/* 디테일 페이지네이션 */}
        <BoardDetailPagination />
        {/* 디테일 댓글 섹션 */}
        {bc.board.reply_status === 1 && (
          <div className="mt-[60px] lg:mt-20">
            <CommentContext.Provider
              value={{
                foreignIdx: bc?.idx || null,
                foreignUserIdx: bc?.user?.idx || null,
              }}
            >
              <ReplySection />
            </CommentContext.Provider>
          </div>
        )}
      </Area>
    </div>
  );
}
